import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import * as Xml2js from 'xml2js';
import { JwtService } from './jwt.service';

var jsonResponse: any;

@Injectable()
export class ApiService {
  constructor(
    private http: Http,
    private jwtService: JwtService
  ) { }

  private setHeaders(): Headers {
    var headersConfig;
    var authenToken = localStorage.getItem("authenToken");
    if (localStorage.getItem("authenToken") != null) {
      headersConfig = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': authenToken
      };
    } else {
      headersConfig = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      };
    }
    return new Headers(headersConfig);
  }

  private formatErrors(error: any) {
    return Observable.throw(error.json());
  }

  get(path: string): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { headers: this.setHeaders() })
      .catch(this.formatErrors)
      .map((res: Response) => res["_body"]);
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    )
      .catch(this.formatErrors)
      .map((res: Response) => res["_body"]);
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    )
      .catch(
      this.formatErrors
      )
      .map((res: Response) => res["_body"]);
  }

  delete(path): Observable<any> {
    return this.http.delete(
      `${environment.api_url}${path}`,
      { headers: this.setHeaders() }
    )
      .catch(this.formatErrors)
      .map((res: Response) => res.toString());
  }

}



// WEBPACK FOOTER //
// ./src/app/api/api.service.ts